import React, { useMemo } from "react";
import { useQRModal } from "../../../../Context/QrContext";
import { useTranslation } from "react-i18next";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import DeleteIcon from "@mui/icons-material/Delete";
import PrintIcon from "@mui/icons-material/Print";

const DisassembleTable = ({ tableHeader, tablebody, selectedBatch, onEdit, onPrint, setTableBody, pageName }) => {
    const { printedRowss, PrintLabel, setPrintedRows } = useQRModal();
    const { t } = useTranslation();

    const formattedHeaders = useMemo(() => {
        const headers = tableHeader?.filter(h => h !== "line_Id" && h !== "issues_Batch" && h.toLowerCase() !== "remarks") || [];
        return ['issues_Batch', ...headers];
    }, [tableHeader]);

    const groupedDataSorted = useMemo(() => {
        const grouped = tablebody?.reduce((acc, row) => {
            const key = row.issues_Batch || "Unassigned";
            if (!acc[key]) acc[key] = [];
            acc[key].push(row);
            return acc;
        }, {}) || {};

        const entries = Object.entries(grouped);

        // Move selected batch group to the top
        if (selectedBatch?.batch_Number) {
            const selectedIndex = entries.findIndex(([key]) => key === selectedBatch.batch_Number);
            if (selectedIndex > -1) {
                const [selectedEntry] = entries.splice(selectedIndex, 1);
                entries.unshift(selectedEntry);
            }
        }
        return entries;
    }, [tablebody, selectedBatch]);

    return (
        <div className="table-responsive">
            <table className="table table-bordered">
                <thead>
                    <tr>
                        {(pageName === 'disassemblpage' || pageName === 'productionfg' || pageName === 'GRPO') && (
                            <th className="table-header sno-column sticky-col">{t("S.No")}</th>
                        )}

                        {formattedHeaders.map((col, index) => (
                            <th key={index} className="table-header">{t(col)}</th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {groupedDataSorted.map(([batch, rows], groupIndex) => (
                        <React.Fragment key={groupIndex}>
                            <tr className="group-header">
                                <td colSpan={formattedHeaders.length + ((pageName !== 'Disassemble' && pageName !== 'productionfg') ? 2 : 1)}>
                                    <strong>{t("Batch Number")}: {batch}</strong>
                                </td>
                            </tr>

                            {rows.map((row, rowIndex) => {
                                const isDisabled = row.disabled;

                                return (
                                    <tr key={`${batch}-${rowIndex}`} className={isDisabled ? 'disabled-row' : ''}>
                                        {(pageName === 'disassemblpage' || pageName === 'productionfg' || pageName === 'GRPO') && (
                                            <td className='sno-column sticky-col'>{rowIndex + 1}</td> // ✅ group-level SNo
                                        )}
                                        {formattedHeaders.map((col, colIndex) => (
                                            <td key={colIndex}>{row[col]}</td>
                                        ))}
                                    </tr>
                                );
                            })}
                        </React.Fragment>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default DisassembleTable;
